// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".network[data-v-46917b94] {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n.network img[data-v-46917b94] {\n  width: 6.25vw;\n  height: 6.25vw;\n}\n.network .text[data-v-46917b94] {\n  color: #000;\n  text-align: center;\n  font-size: 1.04167vw;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 2.39583vw;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
